import * as $html from '../modules/html'

export default {
  install(Vue) {
    Object.assign(Vue.prototype, { $html })
  },
}
